import React from "react";
import adminSvg from "../../../assets/images/admin.svg";
import messagesSvg from "../../../assets/images/messages.svg";
import sessionSvg from "../../../assets/images/session.svg";
import studioSvg from "../../../assets/images/studio.svg";

interface NavLink {
  label: string;
  href: string;
  icon: string;
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

interface AdminLink {
  label: string;
  href: string;
  icon: string;
  active?: boolean;
}

interface BottomHeaderNavProps {
  navLinks: NavLink[];
  adminLink: AdminLink;
}

const iconMap: Record<string, string> = {
  "admin.svg": adminSvg,
  "session.svg": sessionSvg,
  "studio.svg": studioSvg,
  "messages.svg": messagesSvg,
  // Also try without .svg extension in case that's how the data is passed
  admin: adminSvg,
  session: sessionSvg,
  studio: studioSvg,
  messages: messagesSvg,
};

// Helper function to get the correct icon
const getIconSrc = (iconName: string, label: string): string => {
  // First try the iconMap
  if (iconMap[iconName]) {
    return iconMap[iconName];
  }

  // Fallback based on label if iconMap doesn't match
  const labelLower = label.toLowerCase();
  if (labelLower.includes("session")) return sessionSvg;
  if (labelLower.includes("message")) return messagesSvg;
  if (labelLower.includes("studio")) return studioSvg;
  if (labelLower.includes("admin")) return adminSvg;

  // Default fallback
  return sessionSvg;
};

export const BottomHeaderNav: React.FC<BottomHeaderNavProps> = ({
  navLinks,
  adminLink,
}) => (
  <div className="bottom-header">
    <div className="container">
      <div className="left">
        <nav
          className="main-nav"
          itemScope
          itemType="http://schema.org/SiteNavigationElement"
        >
          <ul>
            {navLinks.map((item) => (
              <li key={item.label}>
                <a href={item.href} className={item.active ? "active" : ""}
                  onClick={(e) => {
                    if (item.onClick) {
                      e.preventDefault();
                      item.onClick(e);
                    }
                  }}
                >
                  <img
                    src={getIconSrc(item.icon, item.label)}
                    alt={item.label + " icon"}
                    className="nav-svg"
                    onError={() => {
                      console.log(
                        "Icon failed to load:",
                        item.icon,
                        "Available icons:",
                        Object.keys(iconMap)
                      );
                    }}
                  />
                  <span>{item.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="right">
        <ul>
          <li>
            <a href={adminLink.href} target="_self" className={adminLink.active ? "active" : ""}>
              <img
                src={getIconSrc(adminLink.icon, adminLink.label)}
                alt={adminLink.label + " icon"}
                className="nav-svg"
                onError={() => {
                  console.log(
                    "Admin icon failed to load:",
                    adminLink.icon,
                    "Available icons:",
                    Object.keys(iconMap)
                  );
                }}
              />
              <span>{adminLink.label}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
);
